import { BirthdateSchema } from '@ca/common'
import { zodResolver } from '@hookform/resolvers/zod'
import { trpc } from 'api'
import useSession, { useCustomer } from 'hooks/useSession'
import { useMemo } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

export const schema = z.object({
  birth_date: BirthdateSchema,
})

export const useBirthDateForm = () => {
  const customer = useCustomer()

  const customerBirthdate = customer?.birth_date

  const defaultValues = useMemo(
    () => ({
      birth_date: customerBirthdate ? new Date(customerBirthdate) : undefined,
    }),
    [customerBirthdate]
  )

  const form = useForm({
    defaultValues,
    resolver: zodResolver(schema),
  })

  const setCustomerData = useSession((s) => s.setCustomerData)

  const patchCustomer = trpc.customer.patch.useMutation({
    onSuccess: (res) => {
      setCustomerData(res)
    },
  })

  const onSubmit = form.handleSubmit(({ birth_date }) => {
    if (!customer) return
    patchCustomer.mutate({
      id: customer.id,
      birth_date: birth_date?.toISOString().split('T')[0],
    })
    return true
  })

  const isCustomerSubmitted = form.formState.isSubmitSuccessful
  const show = !customerBirthdate || isCustomerSubmitted

  return {
    form,
    onSubmit,
    show,
    isLoading: patchCustomer.isPending,
  }
}
